import { apiSlice } from "./apiSlice";

export const hseSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all HSE list
        getHSEList: builder.query({
            query: (params) => ({
                url: `HSEData`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllHSEData"],
        }),

        // Create new HSE
        createHSE: builder.mutation({
            query: ({ body }) => ({
                url: `HSEData`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllHSEData"],
        }),

        // Get all HSE list (Month-Year Filter + View Type)
         getHSEViewTypeList: builder.query({
            query: ({ ProjectId, section, monthyear, viewtype }) => ({
                 url: `HSEData/chart-data?projectId=${ProjectId}&MonthYear=${monthyear}&ViewType=${viewtype}&Section=${section}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

    })
})

export const {useGetHSEListQuery, useLazyGetHSEListQuery, useCreateHSEMutation, useGetHSEViewTypeListQuery } = hseSlice;
